import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { ErrorFormattersListQuery, GetNotificationFormatterInput } from '../gql-types.generated';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const QUERY_ERROR_FORMATTERS_LIST = gql`
    query errorFormattersList($input: GetNotificationFormatterInput!) {
        notificationFormatters (input: $input) {
            nodes {
                id
                description
            }
        }
    }
`;

export const queryErrorFormatterList = async (client: ApolloClient<NormalizedCacheObject>) => {
    
    const { data, errors } = await client.query<ErrorFormattersListQuery>({
        variables: {
            input: {
                isForError: true
            }
        },
        query: QUERY_ERROR_FORMATTERS_LIST,
    });

    if (errors && errors.length > 0) {
        errors.forEach(error => {
            // Log error details in the console.
            console.error(error);
        });
        // Friendly error to the user.
        throw new Error('An error has occurred during the query.');
    }

    return data?.notificationFormatters?.nodes;
};